import { useState, useEffect } from "@wordpress/element";
import { cn } from "@/lib/utils";
import {
	setBigCursorVariant,
	getBigCursorVariants,
	getBigCursorVariantAssets,
} from "@/lib/feature-style";
import { ALargeSmall } from "lucide-react";

export default function BigCursorVariantPicker({
	variants = getBigCursorVariants(),
}) {
	const [current, setCurrent] = useState(() => {
		if (typeof localStorage !== "undefined") {
			return (
				localStorage.getItem("accessibility-widget-bigCursor-variant") ||
				"default"
			);
		}
		return "default";
	});

	useEffect(() => {
		const handler = (e) => {
			if (e.detail?.variant) setCurrent(e.detail.variant);
		};
		window.addEventListener("bigCursor-variant-changed", handler);
		return () =>
			window.removeEventListener("bigCursor-variant-changed", handler);
	}, []);

	const assets = getBigCursorVariantAssets();

	return (
		<div className="zn:!mt-1.5  " onClick={(e) => e.stopPropagation()}>
			{/* Variant grid */}
			<div className="zn:flex zn:flex-wrap zn:gap-1.5 zn:justify-center">
				{variants.map((v) => (
					<span
						key={v}
						onClick={() => setBigCursorVariant(v)}
						className={cn("", {
							"zn:opacity-100": current === v,
							"zn:opacity-50": current !== v,
						})}
						aria-label={`Big cursor variant ${v}`}
					>
						{v === "default" && (
							<span>
								<svg
									width={16}
									height={16}
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M2 2L10 22L10.3964 17.6393C10.5658 15.7755 11.3833 14.03 12.7067 12.7067C14.03 11.3833 15.7755 10.5658 17.6393 10.3964L22 10L2 2Z"
										fill="url(#paint0_linear_1799_3032)"
									/>
									<path
										d="M9.99934 22.9995C9.79958 22.9993 9.60445 22.9394 9.43904 22.8274C9.27363 22.7154 9.1455 22.5565 9.07114 22.3711L1.07114 2.37114C0.998694 2.18942 0.981107 1.99045 1.02055 1.79885C1.06 1.60724 1.15474 1.4314 1.29307 1.29307C1.4314 1.15474 1.60724 1.06 1.79885 1.02055C1.99045 0.981107 2.18942 0.998694 2.37114 1.07114L22.3711 9.07114C22.5799 9.15445 22.7546 9.30568 22.8669 9.50044C22.9791 9.69519 23.0225 9.9221 22.99 10.1445C22.9575 10.367 22.851 10.572 22.6877 10.7265C22.5244 10.8809 22.3137 10.9759 22.0898 10.9959L17.729 11.3924C16.0982 11.5403 14.5708 12.2554 13.4129 13.4134C12.2549 14.5713 11.5398 16.0987 11.3919 17.7295L10.9954 22.0895C10.9751 22.3133 10.88 22.5237 10.7255 22.6868C10.571 22.85 10.3662 22.9564 10.1438 22.9889C10.096 22.9958 10.0477 22.9994 9.99934 22.9995ZM3.79424 3.79444L9.38064 17.7602L9.39934 17.5483C9.58952 15.4512 10.5091 13.4873 11.9981 11.9983C13.4871 10.5093 15.451 9.58972 17.5481 9.39954L17.76 9.38044L3.79424 3.79444Z"
										fill="#111927"
									/>
									<path
										d="M9.29199 10.7062L7.29199 8.70619C7.19848 8.61347 7.1242 8.50318 7.07342 8.38168C7.02264 8.26017 6.99637 8.12983 6.9961 7.99814C6.99583 7.86645 7.02157 7.736 7.07185 7.61429C7.12213 7.49258 7.19595 7.38199 7.28909 7.28889C7.38222 7.19578 7.49282 7.12199 7.61455 7.07174C7.73628 7.0215 7.86673 6.99579 7.99842 6.9961C8.13011 6.9964 8.26045 7.02272 8.38194 7.07353C8.50343 7.12434 8.61369 7.19865 8.70639 7.29219L10.7064 9.29219C10.8925 9.48003 10.9967 9.73397 10.9961 9.99842C10.9955 10.2629 10.8901 10.5163 10.7031 10.7033C10.5161 10.8903 10.2626 10.9956 9.99814 10.9961C9.73368 10.9966 9.47978 10.8924 9.29199 10.7062Z"
										fill="#111927"
									/>
									<defs>
										<linearGradient
											id="paint0_linear_1799_3032"
											x1={3}
											y1={2}
											x2={15.5}
											y2={27}
											gradientUnits="userSpaceOnUse"
										>
											<stop offset={0.0702716} stopColor="#D1FCFF" />
											<stop offset={1} stopColor="#2970FF" />
										</linearGradient>
									</defs>
								</svg>
							</span>
						)}
						{v !== "default" && (
							<span
								className="zn:w-4 zn:h-4 zn:inline-block"
								style={{
									backgroundImage: `url(${assets[v]})`,
									backgroundRepeat: "no-repeat",
									backgroundPosition: "center",
									backgroundSize: "contain",
									// Provide a visible fallback shape if image fails
								}}
							/>
						)}
					</span>
				))}
			</div>
		</div>
	);
}
